import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faCog } from '@fortawesome/pro-light-svg-icons'

import {
  Box, Button, Text,
} from '@domain-group/suit-theme'

import { digObject, formatDate } from '@domain-group/javascript-utils'

import EnabledPermission from '@components/EnabledPermission'
import CarouselControls from '@components/CarouselControls'

import useImage from '@hooks/useImage'
import type { UseCarouselPayload } from '@hooks/useCarousel'
import type { CampaignModel, ImageModel } from '@models/types'
import { getCampaignType } from '@functions/campaign'

interface PreviewProps {
  callbacks: {
    unselectImage: () => void,
  },
  campaign: CampaignModel,
  carouselPayload: UseCarouselPayload,
  image: ImageModel,
}

const Preview = (props: PreviewProps) => {
  const {
    callbacks: { unselectImage }, campaign, carouselPayload, image: initImage,
  } = props

  const {
    callbacks: {
      createOrEditImage,
    },
    image,
  } = useImage(initImage)

  const {
    // @ts-expect-error TS2339
    dates, file_file_name, large_url, size,
  } = image

  const createdDate = digObject(dates, 'created.date_time')
  const formattedDate = formatDate(createdDate, 'dd/MM/yyyy HH:mm', 'ccc d LLL yy \'at\' HH:mma')

  const imagePreviewHeight = digObject(size, 'original.height')
  const imagePreviewWidth = digObject(size, 'original.width')

  return (
    <Box
      borderBottom="1px solid"
      borderColor="lineColor"
      flexDirection="column"
    >
      <Box padding="large">
        <Box position="relative">
          <Box
            as="img"
            borderRadius="5px"
            height="auto"
            // @ts-expect-error TS2322
            src={large_url}
          />

          <CarouselControls
            callbacks={{ closeCarousel: () => unselectImage() }}
            carouselPayload={carouselPayload}
          />
        </Box>
      </Box>

      <Box flexDirection="row" padding="large" paddingTop={0}>
        <Box flexDirection="column">
          <Text>{file_file_name}</Text>

          <Text
            color="bodyFontLightColor"
            display={['none', 'block']}
            fontSize="xsmall"
            marginTop="small"
            variant="ellipsis"
          >
            {`Created ${formattedDate} - ${imagePreviewWidth}x${imagePreviewHeight}px`}
          </Text>
        </Box>

        <EnabledPermission
          campaignType={getCampaignType(campaign)}
          permissionKey="campaign.media.manage"
        >
          <Box marginLeft="auto" width="auto">
            <Button
              buttonStyle="secondaryUtility"
              icon={<FontAwesomeIcon icon={faCog} />}
              onClick={() => createOrEditImage({ callbacks: { afterDeleteAction: () => unselectImage() } })}
              size="small"
              style={{ whiteSpace: 'nowrap' }}
            >
              Manage Image
            </Button>
          </Box>
        </EnabledPermission>
      </Box>
    </Box>
  )
}

export default Preview
